import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { CopySource } from 'app/model/pipeline/copysource/copysource';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { HttpStoreReadSettings } from 'app/model/pipeline/copysource/store-read-settings/http-store-read-settings';
import { StoreReadSettingsAdapter } from './store-read-settings.adapter';
import _ from 'lodash';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(HttpStoreReadSettings),
    asynchronous: true,
    adapts: {
        type: '*',
        maxConcurrentConnections: '*',
        requestMethod: '*',
        additionalHeaders: '*',
        requestBody: '*',
        requestTimeout: '*'
    }
})
export class HttpStoreReadSettingsAdapter extends StoreReadSettingsAdapter<
    HttpStoreReadSettings,
    Model.HttpStoreReadSettings
> {
    protected override async _toModel(
        resource: Model.HttpStoreReadSettings,
        copySource: CopySource
    ): Promise<HttpStoreReadSettings> {
        const model = await super._toModel(resource, copySource);
        ValueAdapter.toModel(model, HttpStoreReadSettings.MAXCONCURRENT_CONNECTIONS, resource.maxConcurrentConnections);
        ValueAdapter.toModel(model, HttpStoreReadSettings.REQUEST_METHOD, resource.requestMethod);
        ValueAdapter.toModel(model, HttpStoreReadSettings.ADDITIONAL_HEADERS, resource.additionalHeaders);
        ValueAdapter.toModel(model, HttpStoreReadSettings.REQUEST_BODY, resource.requestBody);
        ValueAdapter.toModel(model, HttpStoreReadSettings.REQUEST_TIMEOUT, resource.requestTimeout);

        return model;
    }

    protected override async _toResource(settings: HttpStoreReadSettings): Promise<Model.HttpStoreReadSettings> {
        const resource = await super._toResource(settings);
        resource.maxConcurrentConnections = ValueAdapter.toResource(
            settings,
            HttpStoreReadSettings.MAXCONCURRENT_CONNECTIONS
        );
        resource.requestMethod = ValueAdapter.toResource(settings, HttpStoreReadSettings.REQUEST_METHOD) || undefined;
        resource.additionalHeaders =
            ValueAdapter.toResource(settings, HttpStoreReadSettings.ADDITIONAL_HEADERS) || undefined;
        resource.requestBody = ValueAdapter.toResource(settings, HttpStoreReadSettings.REQUEST_BODY) || undefined;
        resource.requestTimeout = ValueAdapter.toResource(settings, HttpStoreReadSettings.REQUEST_TIMEOUT);

        return resource;
    }
}
